module.exports = __webpack_public_path__ + "img/logo-light-theme.ffdcc74f.svg";